import {
  BRAND_EDGE_QUESTIONS,
  BRAND_EDGE_TAGLINE_QUESTION,
  BVA_SECTIONS,
  HUMAN_TENSION_QUESTIONS,
  HUMAN_TENSION_TAGLINE_QUESTION,
  MEANINGFUL_BRAND_ROLE_QUESTION,
  PRODUCT_EDGE_QUESTIONS,
  PRODUCT_EDGE_TAGLINE_QUESTION,
} from 'constants/bvaQuestions'
import { Section } from 'model/section'
import { getAnswer } from 'utils/bvaSections'

export interface BvaPdfCell {
  question: string
  answer: string
}

export interface BvaPdfContent {
  humanTension: BvaPdfCell[]
  productEdge: BvaPdfCell[]
  brandEdge: BvaPdfCell[]
  tensionTagline: string
  productEdgeTagline: string
  brandEdgeTagline: string
  meaningfulBrandRole: string
}

const cells = (sections: Section[], section: string, questions: readonly string[]): BvaPdfCell[] =>
  questions.map(question => ({ question, answer: getAnswer(sections, section, question).trim() }))

export const buildBvaPdfContent = (sections: Section[]): BvaPdfContent => ({
  humanTension: cells(sections, BVA_SECTIONS.humanTension, HUMAN_TENSION_QUESTIONS),
  productEdge: cells(sections, BVA_SECTIONS.productEdge, PRODUCT_EDGE_QUESTIONS),
  brandEdge: cells(sections, BVA_SECTIONS.brandEdge, BRAND_EDGE_QUESTIONS),
  tensionTagline: getAnswer(sections, BVA_SECTIONS.humanTension, HUMAN_TENSION_TAGLINE_QUESTION).trim(),
  productEdgeTagline: getAnswer(sections, BVA_SECTIONS.productEdge, PRODUCT_EDGE_TAGLINE_QUESTION).trim(),
  brandEdgeTagline: getAnswer(sections, BVA_SECTIONS.brandEdge, BRAND_EDGE_TAGLINE_QUESTION).trim(),
  meaningfulBrandRole: getAnswer(sections, BVA_SECTIONS.meaningfulBrandRole, MEANINGFUL_BRAND_ROLE_QUESTION).trim(),
})
